
import {Component, Vue} from 'vue-property-decorator';
import {DeepLoop} from '@/common/deepLoop/deepLoop';
import {Util, getPageAPIs} from '@/common/util';
import {shareConfirmOptions} from '@/common/config';
import PlatformNoticeAPI from '@/common/api/operationManage/platformNotice';

export const pageApiList = getPageAPIs(PlatformNoticeAPI);

const defaultForm = {
  title: '',
};

// 平台:1熊猫球社 2国粹馆 3众享
const platformOptions = [
  {value: 1, label: '熊猫球社'},
  {value: 2, label: '国粹馆'},
  {value: 3, label: '众享'},
];

const platform2ch: any = {
  1: '熊猫球社',
  2: '国粹馆',
  3: '众享',
};

// 展示时间:1一次 2每日展示
const displayTypeOptions = [
  {value: 1, label: '一次'},
  {value: 2, label: '每日展示'},
];

const defaultForms: any = {
  platform: 1, // 默认选中熊猫球社
  title: '',
  content: '',
  publish_time: null,
  expire_time: null,
  display_type: 1, // 默认一次
};

@Component({})
export default class PlatformNotice extends Vue {
  private PlatformNoticeAPI: any;
  private is_show: boolean = false;
  private form: any = {};
  private forms: any = {};
  private platformOptions: any[] = platformOptions;
  private platform2ch: any = platform2ch;
  private displayTypeOptions: any[] = displayTypeOptions;

  private deepLoopUtil: any;

  constructor() {
    super();
    this.PlatformNoticeAPI = new PlatformNoticeAPI();

    this.deepLoopUtil = new DeepLoop();

    this.forms = {
      ...this.deepLoopUtil.deepCopy(defaultForms, false),
    };

    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm, false),
    };
  }

  private tableData: any[] = [];
  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  private activated(): void {
    this.search();
  }

  private getTable(): void {
    const form = this.form || {};
    const {title} = form;

    const params: any = {
      page: this.tablePage.pageNo,
      limit: this.tablePage.pageSize,
    };

    if (title && title.trim()) {
      params.title = title.trim();
    }

    this.PlatformNoticeAPI.list(
        params,
        (res: any) => {
          this.tableData = res.data.list;
          this.tablePage.totalCount = res.data.count;
        }
    );
  }

  private restForm(): void {
    this.form = new Util().clearObject(this.form);
    this.getTable();
  }

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;
    this.getTable();
  }

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;
    this.getTable();
  }

  private handleWakeAddDialog(): void {
    this.forms = {
      ...this.deepLoopUtil.deepCopy(defaultForms, false),
    };
    this.is_show = true;
  }

  private getFormsParams() {
    const forms: any = this.forms;

    const {
      platform,
      title,
      content,
      publish_time,
      expire_time,
      display_type,
    } = forms || {};

    if (!title || title.trim().length < 2 || title.trim().length > 20) {
      this.$message.error('标题必填，范围为2-20个字符');
      return false;
    }

    if (!content || content.trim().length < 10 || content.trim().length > 500) {
      this.$message.error('文案必填，范围为10-500个字符');
      return false;
    }

    if (!publish_time) {
      this.$message.error('请选择发布时间');
      return false;
    }

    if (this.getTime(publish_time) <= this.getTime(new Date())) {
      this.$message.error('发布时间必须大于当前时间');
      return false;
    }

    if (!expire_time) {
      this.$message.error('请选择失效时间');
      return false;
    }

    if (this.getTime(expire_time) <= this.getTime(publish_time)) {
      this.$message.error('失效时间必须大于发布时间');
      return false;
    }

    return {
      platform,
      title: title.trim(),
      content: content.trim(),
      publish_time,
      expire_time,
      display_type,
    };
  }

  private getTime(time: any): number {
    if (time instanceof Date) {
      return time.getTime();
    }
    return new Date(String(time).replace(/-/g, '/')).getTime();
  }

  private submit(): void {
    const params = this.getFormsParams();

    if (typeof params !== 'object') {
      return;
    }

    this.PlatformNoticeAPI.add(params, () => {
      this.is_show = false;
      Util.showToast('新增成功');
      this.search();
    });
  }

  private delNotice(row: any) {
    this.$confirm(`确定删除该公告?`, '', {
      ...shareConfirmOptions,
    }).then(() => {
      this.PlatformNoticeAPI.delete(
          {
            id: row.id,
          },
          () => {
            Util.showToast('删除成功');
            this.search();
          }
      );
    });
  }
}
